<div class="bankruptcies-form-container">
	<form [formGroup]="bankruptciesFormGroup" #formBankruptciesDirective="ngForm" (submit)="submitBankruptciesForm(formBankruptciesDirective, $event)">
		<div class="row mx-1 mt-2">
			<div class="col">
				<mat-form-field class="field-with-insert-button w-100 pb-2">
					<mat-label>{{ 'BANKRUPTCIES.COMPANY' | translate }}</mat-label>
					<input type="text" matInput formControlName="company" [matAutocomplete]="companyAutoComplete" />
					<mat-autocomplete
						#companyAutoComplete
						[displayWith]="displayFnBusinessEntity.bind(this)"
						(optionSelected)="itemAction('SELECT', 'COMPANY', bankruptciesFormGroup.controls['company'].value)">
						@for (company of filteredBusinessEntities; track $index) {
						<mat-option [value]="company">{{ utils.getParameterByLanguageScript(company, 'name', true) }}</mat-option>
						}
					</mat-autocomplete>
					<button
						matSuffix
						mat-button
						type="button"
						color="primary"
						aria-label="Add business entity"
						matTooltip="{{ 'BUTTON.CREATE' | translate }} {{ 'BUSINESS_ENTITY.TITLE' | translate }}"
						matTooltipPosition="below"
						(click)="itemAction('CREATE', 'COMPANY', bankruptciesFormGroup.controls['company'].value)">
						<mat-icon class="m-0">add</mat-icon>
					</button>
				</mat-form-field>

				<mat-form-field class="w-100 pb-2">
					<mat-label>{{ 'BANKRUPTCIES.EMBS' | translate }}</mat-label>
					<input type="text" matInput formControlName="embs" readonly />
				</mat-form-field>

				<mat-form-field class="field-with-insert-button w-100 pb-2">
					<mat-label>{{ 'CONTRACT_NOTICES.PDF_FILE' | translate }} / {{ 'BANKRUPTCIES.IMAGE' | translate }}</mat-label>
					<input type="text" matInput formControlName="fileUrl" readonly />
					<button
						type="button"
						matSuffix
						mat-flat-button
						color="primary"
						aria-label="Upload image"
						matTooltip="{{ 'BUTTON.UPLOAD' | translate }}"
						matTooltipPosition="below"
						(click)="fileInput.click()">
						<mat-icon class="m-0">upload</mat-icon>
					</button>
					<input type="file" hidden #fileInput [accept]="getAcceptedFormats()" (change)="selectFilesForUpload($event)" />
				</mat-form-field>

				<mat-form-field class="w-100 pb-2">
					<mat-label
						>{{ 'BANKRUPTCIES.PHASE' | translate }}
						<!-- workaround for material-chrome bug -->
						<select id="phase" style="display: none"></select>
					</mat-label>
					<mat-select formControlName="phase">
						@for (phase of phases; track $index) {
						<mat-option [value]="phase">{{ 'BANKRUPTCIES.PHASES.' + phase | translate }}</mat-option>
						}
					</mat-select>
				</mat-form-field>

        <mat-form-field class="w-100">
          <mat-label>{{ 'BANKRUPTCIES.PUBLISHED_DATE' | translate }}</mat-label>
          <input matInput id="published-date" [matDatepicker]="publishedDatePicker" formControlName="publicationDate" />
          <mat-datepicker-toggle matIconSuffix [for]="publishedDatePicker"></mat-datepicker-toggle>
          <mat-datepicker #publishedDatePicker></mat-datepicker>
        </mat-form-field>

			</div>
			<div class="col ps-0">
				<mat-form-field class="w-100 h-100">
					<mat-label>{{ 'BANKRUPTCIES.TEXT' | translate }}</mat-label>
					<textarea matInput cdkTextareaAutosize cdkAutosizeMinRows="8" formControlName="text"></textarea>
				</mat-form-field>
			</div>
		</div>

		<div class="d-flex mt-3 mx-3">
			<button
				type="button"
				mat-raised-button
				color="primary"
				class="me-1"
				aria-label="Reset form button"
				matTooltip="{{ 'ASSORTED.RESET_FORM' | translate }}"
				matTooltipPosition="below"
				[disabled]="apiLoading"
				(click)="resetForm(formBankruptciesDirective)">
				<mat-icon class="m-0">restart_alt</mat-icon>
			</button>

			<button
				type="submit"
				mat-raised-button
				color="primary"
				class="w-100"
				aria-label="Submit form button"
				[disabled]="!checkFormValidity() || bankruptciesFormGroup.invalid || apiLoading">
				@if(apiLoading) {
				<mat-spinner diameter="20"></mat-spinner>
				} @else {
				{{ 'BUTTON.' + mode | translate }} {{ 'BANKRUPTCIES.BANKRUPTCY' | translate }}
				}
			</button>
		</div>
	</form>
</div>
